import Vue from 'vue'
import Vuex from 'vuex'
import localforage from 'localforage'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userInfo: null,
    userExtraInfo: null,
    gradSize: 0,
    pictogramColor: 0,
    movingOrExcluding: false,
    pictogramType: '',
    cards: []
  },

  actions: {
    setUserInfo (context, userInfo) {
      return new Promise((resolve, reject) => {
        (async () => {
          try {
            await localforage.setItem('userinfo', userInfo)
            context.commit('setUserInfo', userInfo)
            resolve()
          } catch (e) {
            reject(e)
          }
        })()
      })
    },

    setUserExtraInfo (context, userExtraInfo) {
      return new Promise((resolve, reject) => {
        (async () => {
          try {
            await localforage.setItem('userextrainfo', userExtraInfo)
            context.commit('setUserExtraInfo', userExtraInfo)
            resolve()
          } catch (e) {
            reject(e)
          }
        })()
      })
    },

    checkLocalInfo (context) { // checa se existe token e informações locais e commita se existir
      return new Promise((resolve, reject) => {
        (async () => {
          try {
            const userinfo = await localforage.getItem('userinfo')
            const userextrainfo = await localforage.getItem('userextrainfo')
            context.commit('setUserInfo', userinfo)
            context.commit('setUserExtraInfo', userextrainfo)
            resolve()
          } catch (e) {
            reject(e)
          }
        })()
      })
    },

    logout (context) {
      return new Promise((resolve, reject) => {
        (async () => {
          try {
            await localforage.removeItem('userinfo')
            await localforage.removeItem('userextrainfo')
            context.commit('setUserInfo', null)
            context.commit('setUserExtraInfo', null)
          } catch (e) {
            reject(e)
          }
        })()
      })
    }
  },

  getters: {
    getUserInfo (state) {
      return state.userInfo
    },
    getUserExtraInfo (state) {
      return state.userExtraInfo
    },
    getPictogramType (state) {
      return state.pictogramType
    }
  },

  mutations: {
    setUserInfo (state, userinfo) {
      state.userInfo = userinfo
    },
    setUserExtraInfo (state, userextrainfo) {
      state.userExtraInfo = userextrainfo
    },
    setGradSize (state, size) {
      state.gradSize = size
    },
    setPictogramColor (state, color) {
      state.pictogramColor = color
    },
    setPictogramType (state, type) {
      state.pictogramType = type
    },
    setMovingOrExcluding (state, value) {
      state.movingOrExcluding = value
    },
    setCards (state, cards) {
      state.cards = cards
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js